import {
  PLATFORM_PROFILE_FBO_TYPE,
  PLATFORM_TYPE,
} from "../../utils/constants";
import { getUrls } from "../../utils/urls";
import useApiWrapper from "./useApiWrapper";

const useFBOApi = () => {
  const { fetchWithAuth, downloadFileWithAuth } = useApiWrapper();
  const URLS = getUrls();

  const fetchListOfAirport = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRPORT);
  };

  const fetchFBOUserProfile = async () => {
    return await fetchWithAuth(URLS.GET_FBO_USER_PROFILE);
  };

  const fetchListOfAircraft = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRCRAFT);
  };

  const fetchLandingFeeData = async (fboData) => {
    const queryParams = new URLSearchParams(fboData).toString();
    return await fetchWithAuth(`${URLS.GET_LANDING_FEE_DATA}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const searchLandingFeeByTripId = async (trackingId, isCommercialFlight) => {
    const queryParams = new URLSearchParams({
      trackingId,
      isCommercialFlight,
    }).toString();
    return await fetchWithAuth(
      `${URLS.SEARCH_LANDING_FEE_BY_TRIP_ID}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const fetchFBOInvoices = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.GET_FBO_INVOICES}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const fetchFBOUnpaidInvoices = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(
      `${URLS.GET_FBO_UNPAID_INVOICES}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const fetchLandingFeeInvoice = async (invoiceId, isCommercialFlight) => {
    const queryParams = isCommercialFlight !== undefined
      ? `?isCommercialFlight=${isCommercialFlight}`
      : "";
    return await fetchWithAuth(
      `${URLS.GET_LANDING_FEE_INVOICE(invoiceId)}${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchFuelRoyaltyInvoice = async (invoiceId) => {
    return await fetchWithAuth(URLS.GET_FUEL_ROYALTY_INVOICE(invoiceId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchLandLeaseInvoice = async (invoiceId) => {
    return await fetchWithAuth(URLS.GET_LAND_LEASE_INVOICE(invoiceId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchListOfFuelMeters = async () => {
    return await fetchWithAuth(URLS.GET_FUEL_METERS);
  };

  const fetchSubmittedFuelReadingData = async (fuelData) => {
    const queryParams = new URLSearchParams(fuelData).toString();
    return await fetchWithAuth(
      `${URLS.GET_SUBMITTED_FUEL_READING}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const fetchFilteredSubmittedFuelReadingData = async (fuelData) => {
    const queryParams = new URLSearchParams(fuelData).toString();
    return await fetchWithAuth(
      `${URLS.GET_FILTERED_SUBMITTED_FUEL_READING}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const addFuelMeterData = async (fuelMeterData) => {
    return await fetchWithAuth(URLS.ADD_FUEL_METER_DATA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fuelMeterData),
    });
  };

  const submitFuelReadingData = async (fuelMeterData) => {
    return await fetchWithAuth(URLS.SUBMIT_FUEL_METER_READING, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fuelMeterData),
    });
  };

  const addLandingFeeData = async (landingFeeData) => {
    return await fetchWithAuth(URLS.ADD_LANDING_FEE_DATA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(landingFeeData),
    });
  };

  const createManualFlightPlan = async (flightPlanData) => {
    return await fetchWithAuth(URLS.CREATE_MANUAL_FLIGHT_PLAN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(flightPlanData),
    });
  };

  

  const fetchListOfCountry = async () => {
    return await fetchWithAuth(URLS.GET_COUNTRIES_LIST);
  };

  const fetchGetFboCustomers = async () => {
    return await fetchWithAuth(URLS.GET_FBO_CUSTOMER);
  };

  const fetchAssociatedFboCustomers = async () => {
    return await fetchWithAuth(URLS.GET_ASSOCIATED_FBO_CUSTOMERS);
  };

  const fetchStateCityList = async (id) => {
    return await fetchWithAuth(URLS.GET_STATES_CITY_LIST(id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const userProfileSetup = async (formData) => {
    return await fetchWithAuth(URLS.USER_PROFILE_SETUP, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
  };

  const fetchFBOProfiles = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.GET_FBO_PROFILES}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  //TODO:- Need to handle the api part when Api is ready from backend
  const deleteFBOProfile = async (associationId) => {
    return await fetchWithAuth(URLS.DELETE_FBO_PROFILE(associationId), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const editFBOProfile = async (associationId, data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(
      `${URLS.EDIT_FBO_PROFILE_ROLE(associationId)}?${queryParams}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const searchFBOProfile = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(`${URLS.SEARCH_FBO_USER}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const inviteFBOUser = async (userData) => {
    return await fetchWithAuth(URLS.INVITE_FBO_USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
  };

  const addDeviceToken = async (deviceToken) => {
    return await fetchWithAuth(
      `${URLS.ADD_DEVICE_TOKEN}?deviceToken=${deviceToken}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const removeDeviceToken = async () => {
    return await fetchWithAuth(`${URLS.REMOVE_DEVICE_TOKEN}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const searchAirport = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRPORT}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchNotificationsUnreadCount = async () => {
    const queryParams = new URLSearchParams({
      platformProfileType: PLATFORM_PROFILE_FBO_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.GET_NOTIFICATIONS_UNREAD_COUNT}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const readAllNotifications = async () => {
    const queryParams = new URLSearchParams({
      platformProfileType: PLATFORM_PROFILE_FBO_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();

    return await fetchWithAuth(
      `${URLS.READ_ALL_NOTIFICATIONS}?${queryParams}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const fetchAllNotifications = async (data) => {
    const queryParams = new URLSearchParams({
      ...data,
      platformProfileType: PLATFORM_PROFILE_FBO_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(`${URLS.GET_All_NOTIFICATIONS}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const readNotifications = async (notificationId, data) => {
    const queryParams = new URLSearchParams({
      ...data,
      platformProfileType: PLATFORM_PROFILE_FBO_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.READ_NOTIFICATION(notificationId)}?${queryParams}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const unreadNotification = async (notificationId, data) => {
    const queryParams = new URLSearchParams({
      ...data,
      platformProfileType: PLATFORM_PROFILE_FBO_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.UNREAD_NOTIFICATION(notificationId)}?${queryParams}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const deleteNotification = async (notificationId, data) => {
    const queryParams = new URLSearchParams({
      ...data,
      platformProfileType: PLATFORM_PROFILE_FBO_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.DELETE_NOTIFICATION(notificationId)}?${queryParams}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const submitWireTransferPayment = async (paymentData) => {
    return await fetchWithAuth(URLS.PAYMENT_VIA_WIRE_TRANSFER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paymentData),
    });
  };

  const fetchBankConfig = async (env) => {
    return await fetchWithAuth(URLS.GET_BANK_CONFIG(env), {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const rejectTrip = async (id, rejectionReason) => {
    return await fetchWithAuth(
      `${URLS.REJECT_TRIP(id)}?rejectionReason=${rejectionReason}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const rejectPrivateTrip = async (id, rejectionReason) => {
    return await fetchWithAuth(
      `${URLS.REJECT_PRIVATE_TRIP(id)}?rejectionReason=${rejectionReason}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const getAirlineById = async (airlineId) => {
    return await fetchWithAuth(URLS.GET_AIRLINE_BY_ID(airlineId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const downloadFBOInvoice = async (dynamicsInvoiceId) => {
    const url = URLS.DOWNLOAD_FBO_INVOICE(dynamicsInvoiceId);
    const fileName = `invoice-${dynamicsInvoiceId}.pdf`;
    return await downloadFileWithAuth(url, fileName);
  };

  const searchAirline = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRLINE}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const searchAircraft = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRCRAFT}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchListOfAirline = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRLINE);
  };
  return {
    fetchListOfAirport,
    fetchFBOUserProfile,
    fetchListOfAircraft,
    fetchLandingFeeData,
    searchLandingFeeByTripId,
    fetchFBOInvoices,
    fetchFBOUnpaidInvoices,
    fetchLandingFeeInvoice,
    fetchFuelRoyaltyInvoice,
    fetchLandLeaseInvoice,
    fetchListOfFuelMeters,
    addLandingFeeData,
    addFuelMeterData,
    fetchSubmittedFuelReadingData,
    fetchFilteredSubmittedFuelReadingData,
    submitFuelReadingData,
    fetchGetFboCustomers,
    fetchAssociatedFboCustomers,
    fetchListOfCountry,
    fetchStateCityList,
    userProfileSetup,
    fetchFBOProfiles,
    deleteFBOProfile,
    editFBOProfile,
    searchFBOProfile,
    addDeviceToken,
    removeDeviceToken,
    searchAirport,
    readAllNotifications,
    fetchNotificationsUnreadCount,
    fetchAllNotifications,
    readNotifications,
    unreadNotification,
    deleteNotification,
    inviteFBOUser,
    submitWireTransferPayment,
    fetchBankConfig,
    rejectTrip,
    rejectPrivateTrip,
    getAirlineById,
    downloadFBOInvoice,
    searchAirline,
    searchAircraft,
    fetchListOfAirline,
    createManualFlightPlan,
  };
};
export default useFBOApi;
